module.exports = {
  dimensions: {
    width: 90,
    height: 96
  },
  nine: {
    top: 28,
    left: 20,
    right: 20,
    bottom: 28
  },
  optical: {
    top: 1,
    left: 1,
    right: 1,
    bottom: 1
  },
  content: {
    top: 28,
    left: 24,
    right: 24,
    bottom: 28
  }
};